import React from "react";
import { Check } from "app/components/Icon";
import { AccessType, Plan } from "services/graphql";
import { useUserHasTrialed } from "hooks/Subscriptions/useUserHasTrialed";
import styles from "./styles.module.scss";

const MUSIC_BENEFIT_MAP: { [key in AccessType]: any } = {
  [AccessType.Basic]: <>Royalty Free Music</>,
  [AccessType.Standard]: <>Royalty Free Music</>,
  [AccessType.Premium]: <>All Music Access</>,
  [AccessType.Free]: <></>,
};

interface Props {
  plan: Plan;
}

export function BenefitsText({ plan }: Props) {
  const { hasTrialed } = useUserHasTrialed();
  const { canTrial, trialPeriod, trialPeriodUnit } = plan;

  const TRIAL_BENEFITS = [
    <>
      {trialPeriod} {trialPeriodUnit} Free Trial
    </>,
    <>Full Dance Library</>,
    <>Exclusive Dance Tools</>,
    MUSIC_BENEFIT_MAP[plan.accessType],
  ];

  const NON_TRIAL_BENEFITS = [
    <>Full Dance Library</>,
    <>Exclusive Dance Tools</>,
    MUSIC_BENEFIT_MAP[plan.accessType],
  ];

  const benefits =
    canTrial && !hasTrialed ? TRIAL_BENEFITS : NON_TRIAL_BENEFITS;

  return (
    <div className={styles.benefitsContainer}>
      {benefits.map((benefit, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={index} className={styles.textContainer}>
          <Check className={styles.icon} />
          <p>{benefit}</p>
        </div>
      ))}
    </div>
  );
}
